module.exports = __webpack_public_path__ + "static/media/kitty.bc7ae1f5.jpeg";